import * as React from "react";
import DefaultMapPage from "../../../common/DefaulMapPage/DefaultMapPage";

const ReadyToExplore = () => (
  <>
    <DefaultMapPage title='Ready to explore?'
                    pageInfo='08 - flatfy local'
    />
  </>

);

export default ReadyToExplore;
